module.exports = __webpack_public_path__ + "assets/img/19_858.01287cae.jpg";